import React, { Component } from 'react'
import { Dropdown, Modal, Button, Table } from 'react-bootstrap'
import { connect } from 'react-redux'
import loading from '../../assets/loading.svg'
import Slide from 'react-reveal/Slide';
import { fetchEwCompanies, selectEwCompany, toggleShowModal } from '../action/ewCompanyActions'
import { filterUsers, selectEwUser, deslectEwUser } from '../action/userActions'
import { getUserFolders } from '../../FTPMgt/action/ftpFolderActions'
import { filterGroupByCo, removeEwGroupSelection } from '../action/ewGroupActions'
import { withRouter } from 'react-router-dom'

class SelectEwCompany extends Component {

    constructor(props) {
        super(props)
        this.state = { search: '', cSearch: '' }
    }

    getAllContexts(user) {
        let contexts = user['securityContextValue'] != 0 ? user['securityContextValue'] : ''

        if (user.Contexts) {
            if (contexts == '')
                contexts += user.Contexts
            else
                contexts += '|' + user.Contexts
        }

        return contexts

    }

    componentDidUpdate(prevProps) {
        if (prevProps.selected != this.props.selected)
            if (this.props.ftp && this.props.selected) {
                this.props.dispatch(getUserFolders(this.props.selected.company['Public Id of Distributor'] ?
                    this.props.selected.company['Public Id of Distributor'] :
                    this.props.selected.company['Public Id of Manufacturer'], null))
            }
    }

    componentDidMount() {
        //  if(this.props.cos.length == 0)
        //   this.props.dispatch(fetchEwCompanies())
    }
    render() {

        var filteredUsers = this.props.allUsers.filter(u => {
            //    u['securityContextValue']
            var name = u['firstName'] + ' ' + u['lastName']

            return name.toLowerCase().includes(this.state.cSearch.toLowerCase())
        })


        var filteredMfrs = this.props.cos.Mfrs ? this.props.cos.Mfrs.filter(m => {

            if (this.state.cSearch.length > 0) {
                var coUser = filteredUsers.filter(u => {
                    return u['securityContextValue'] == m['Public Id of Manufacturer'] || (u.Contexts && u.Contexts.includes(m['Public Id of Manufacturer']))
                })
                return coUser.length > 0
            }

            if (this.state.search.length === 0)
                return true
            if (m['Manufacturer Name'] && m['Public Id of Manufacturer'])
                return m['Manufacturer Name'].toLowerCase().includes(this.state.search.toLowerCase()) || m['Public Id of Manufacturer'].includes(this.state.search)
        }) : []

        var filteredDists = this.props.cos.Dists ? this.props.cos.Dists.filter(m => {

            if (this.state.cSearch.length > 0) {
                var coUser = filteredUsers.filter(u => {
                    if (m['Public Id of Distributor'])
                        return u['securityContextValue'] == m['Public Id of Distributor']
                })
                return coUser.length > 0
            }

            if (this.state.search.length === 0)
                return true
            if (m['Distributor Name'] && m['Public Id of Distributor'])
                return m['Distributor Name'].toLowerCase().includes(this.state.search.toLowerCase()) || m['Public Id of Distributor'].includes(this.state.search)
        }) : []

        const Ddtoggle = (() => {
            if (this.props.selected) {
                if (this.props.selected.company['Manufacturer Name']) {

                    if (this.props.selected.company['Manufacturer Name'] == 'IDEA Users')
                        return 'IDEA Users'


                    return this.props.selected.company['Manufacturer Name'].substring(0, 25) + ' - ' + this.props.selected.company['Public Id of Manufacturer']

                }
                else
                    return this.props.selected.company['Distributor Name'] + ' - ' + this.props.selected.company['Public Id of Distributor']

            }

            return 'SELECT COMPANY'

        })

        return (
            <div >

                <Button class='dropdown-toggle' style={this.props.style} disabled={this.props.loading || this.props.usersLoading || this.props.disabled} onClick={() => this.props.dispatch(toggleShowModal())}>
                    <img hidden={!this.props.loading && !this.props.usersLoading} style={{ height: '40px' }} src={loading} />
                    <Ddtoggle />
                </Button>

                <Modal show={this.props.show} >
                    <Modal.Header>

                        <input disabled={this.state.cSearch.length > 0} onChange={(e) => { this.setState({ search: e.target.value }) }} defaultValue={this.state.search} placeholder='Search Customers' style={{ textAlign: 'center', marginLeft: '1px', width: '99%' }} />
                        <br />
                        <input hidden={this.props.ftp} disabled={this.state.search.length > 0} onChange={(e) => { this.setState({ cSearch: e.target.value }) }} defaultValue={this.state.cSearch} placeholder='Search Users' style={{ textAlign: 'center', marginLeft: '1px', width: '99%' }} />

                    </Modal.Header>
                    <Modal.Body style={{ height: '350px', overflow: 'auto' }}>

                        <Table striped bordered hover hidden={!this.state.cSearch}>
                            <thead>
                                <tr>

                                    <th>Name</th>
                                    <th>Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredUsers.map(m => {
                                    return <tr style={{ cursor: 'pointer' }} onClick={() => {
                                        this.props.dispatch(toggleShowModal())
                                        this.props.dispatch(selectEwUser(m))
                                        this.props.history.push('/create')
                                    }}>
                                        <td>
                                            {m['firstName'] + ' ' + m['lastName']} <small>({m['email']})</small>
                                        </td>
                                        <td>
                                            {this.getAllContexts(m)}
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </Table>

                        <Table striped bordered hover>
                            <thead>
                                <tr>

                                    <th>Name</th>
                                    <th>Code</th>
                                    <th>Type</th>
                                    <th>Subscription Level</th>
                                </tr>
                            </thead>
                            <tbody style={{ overflow: 'auto', height: '350px' }}>
                                {filteredMfrs.map((g, index) => {
                                    return <tr style={{ cursor: 'pointer' }} onClick={() => {
                                        this.props.dispatch(selectEwCompany(g))
                                        this.props.dispatch(deslectEwUser())
                                        this.props.dispatch(filterUsers({ context: g['Public Id of Manufacturer'], allUsers: this.props.allUsers }))
                                        // this.props.dispatch(removeEwGroupSelection())
                                        // console.log('roles', g['Roles'])
                                        //this.props.dispatch(filterGroupByCo(g['Roles']))
                                        this.props.dispatch(toggleShowModal())
                                    }} key={g['Public Id of Manufacturer'] + index} >

                                        <td>
                                            {g['Manufacturer Name']}
                                        </td>

                                        <td>
                                            {g['Public Id of Manufacturer']}
                                        </td>

                                        <td>
                                            {g['Manufacturer Name'] == 'IDEA Users' ? 'ALL' : 'MFR'}
                                        </td>

                                        <td>
                                            {g['Manufacturer Subscription Level']}
                                        </td>

                                    </tr>
                                })}
                                {filteredDists.map((g, index) => {
                                    return <tr style={{ cursor: 'pointer' }} onClick={() => {
                                        this.props.dispatch(selectEwCompany(g))
                                        this.props.dispatch(deslectEwUser())

                                        this.props.dispatch(filterUsers({ context: g['Public Id of Distributor'], allUsers: this.props.allUsers }))
                                        //       this.props.dispatch(filterGroupByCo(g['Roles']))
                                        this.props.dispatch(toggleShowModal())
                                    }} key={g['Public Id of Distributor'] + index} >

                                        <td>
                                            {g['Distributor Name']}
                                        </td>

                                        <td>
                                            {g['Public Id of Distributor']}
                                        </td>

                                        <td>
                                            Dist
          </td>

                                        <td>
                                            {g['Distributor Subscription Level']}
                                        </td>

                                    </tr>
                                })}
                            </tbody>
                        </Table>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={() => this.props.dispatch(toggleShowModal())}
                            variant='danger'>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state => (
    {
        cos: state.acct.ewCo.companies,
        selected: state.acct.ewCo.globalSelect,
        error: state.acct.ewCo.error,
        show: state.acct.ewCo.show,
        loading: state.acct.ewCo.loading,
        allUsers: state.acct.user.users,
        usersLoading: state.acct.user.usersLoading
    });




export default connect(mapStateToProps)(withRouter(SelectEwCompany))